import { Component } from '@angular/core'

@Component({
  selector: 'app-incentive-comparator-loader',
  template: ` <div class="spinner mb-9 spinner--comparator">
    <div class="columns">
      <div class="column is-12">
        <div
          class="is-flex is-align-items-center is-justify-content-space-between my-2"
        >
          <div class="spinner--label"></div>
          <div
            class="is-flex is-align-items-center is-justify-content-space-between my-2"
          >
            <div class="spinner--label mr-4"></div>
            <div class="spinner--label mr-4"></div>
            <div class="spinner--label"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12 pt-0">
        <table class="table is-fullwidth is-bordered">
          <tbody>
            <tr>
              <td width="254"></td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
              <td>
                <div class="spinner--p mb-2"></div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--flag mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div
                  class="is-flex is-align-items-center is-justify-content-flex-start mb-2"
                >
                  <div class="spinner--checkbox mr-2"></div>
                  <div class="spinner--label"></div>
                </div>
                <div class="spinner--p"></div>
              </td>
            </tr>
            <tr class="has-background-grey-lighter" height="25">
              <td height="25" style="padding: 0" width="254"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>

              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>

              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>

              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr class="has-background-grey-lighter" height="25">
              <td height="25" style="padding: 0" width="254"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
              <td height="25" style="padding: 0"></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
            <tr>
              <td width="254"><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
              <td><div class="spinner--p"></div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>`
})
export class IncentiveComparatorLoaderComponent {}
